import VehicleAddonType from "@CheckOrder/types/VehicleAddon.type";
import {
    carPassengerCode,
    largeCarPassengerCode, motorcyclePassengerCode
} from "@CheckOrder/features/addons/features/jadrolinija/constants/vehiclePassengerCodes";

export default function checkPassengerGroupType() {
    const carPassengerCodes = [carPassengerCode, largeCarPassengerCode]
    const isCar = (vehicle: VehicleAddonType) => (
        carPassengerCodes.includes(vehicle.singlePassengerGroupId) || carPassengerCodes.includes(vehicle.returnPassengerGroupId)
    )

    const isMotorcycle = (vehicle: VehicleAddonType) => (
        vehicle.singlePassengerGroupId === motorcyclePassengerCode || vehicle.returnPassengerGroupId === motorcyclePassengerCode
    )

    return {
        isCar,
        isMotorcycle,
    }
}